/**
 * Homepage banner (anonymous API, no token required)
 * @returns {Promise<Object>}
 */
export function fetchPublicHomeBanner() {
  const prefix = process.env.VUE_APP_BASE_API || ''
  return fetch(prefix + '/web/homeBanner/public', {
    method: 'GET',
    headers: { Accept: 'application/json' },
  })
    .then((res) => res.json())
    .then((body) => {
      if (body.code !== 200) {
        throw new Error(body.msg || 'Failed to load banner')
      }
      return body.data || {}
    })
}
